import { useMemo } from "react";
import { Row, Col } from "react-bootstrap";
import Loading from "../../../components/core/blocks/Loading";
import { useDates } from "../../../dates/DatesContext";
import Metric from "../../../components/core/blocks/SummaryMetric";
import MultiMetricChart from "../../../components/custom/merchandise/MultiMetricChart";
import useSelectedMetrics from "../../../components/custom/merchandise/hooks/useSelectedMetrics";
import getMetricSpec from "../../merchandising/utils/metrics";

const Overview = ({ isPricingProductDataLoading, data, isLoading }) => {
  const { selectedMetrics, toggleMetric } = useSelectedMetrics(["price", "units", "total_sales"]);
  const { group } = useDates();

  const metrics = useMemo(
    () => [getMetricSpec("price"), getMetricSpec("units"), getMetricSpec("sales"), getMetricSpec("bsr")],
    [],
  );

  const handleLegendChange = (e) => {
    const id = e.target?.options?.custom?.id;
    if (id) toggleMetric(id);
    return false;
  };

  if (isLoading || isPricingProductDataLoading) {
    return <Loading height={"300px"} fullPage={false} />;
  }

  return (
    <Row>
      <Col xs={8}>
        <MultiMetricChart
          metrics={metrics}
          selectedMetrics={selectedMetrics}
          data={data.date}
          group={group}
          handleLegendChange={handleLegendChange}
        />
      </Col>
      <Col xs={4} className="pt-5">
        <Row>
          {metrics.map((m) => (
            <Col
              key={m.id}
              xs={6}
              style={{ marginBottom: "3rem" }}
              onClick={() => {
                toggleMetric(m.id);
              }}
            >
              <Metric metric={m} data={data?.total} showTarget selected={selectedMetrics.includes(m.id)} />
            </Col>
          ))}
        </Row>
      </Col>
    </Row>
  );
};

export default Overview;
